import { useMemo } from 'react';
import type { DepositWithdrawAssets } from '@/shared/types/dictionaryTypes';
import {
  mapScopeConfigurationToDepositWithdrawAssets,
  useUserScopeConfigurationFull,
} from '@/entities/user';

const useDepositWithdrawAssetsDictionary = () => {
  const {
    userScopeConfigurationFull,
    isUserScopeConfigurationFullLoading,
    userScopeConfigurationFullError,
  } = useUserScopeConfigurationFull();

  const depositWithdrawAssetsData = useMemo<
    { value: DepositWithdrawAssets } | undefined
  >(
    () =>
      userScopeConfigurationFull
        ? {
            value: mapScopeConfigurationToDepositWithdrawAssets(
              userScopeConfigurationFull
            ),
          }
        : undefined,
    [userScopeConfigurationFull]
  );

  return {
    depositWithdrawAssetsData,
    depositWithdrawAssetsLoading: isUserScopeConfigurationFullLoading,
    depositWithdrawAssetsError: userScopeConfigurationFullError,
    depositWithdrawAssetsIsError: !!userScopeConfigurationFullError,
  };
};

export { useDepositWithdrawAssetsDictionary };
